<div class="info-details__header mb-2 rounded-3">
  <div class="info-details__header-content d-flex gap-2">
    <div class="info-details__list d-flex flex-grow-1 flex-wrap">
      <ng-container *ngFor="let item of infoDetailsList">
        <div class="info-details__list-item text-nowrap d-flex" *ngIf="!item.hidden">
          <span class="list-item-key me-2 text-nowrap primary-font">{{ item.key }}</span>
          <span *ngIf="!(item?.badge??false) && item.key != 'SB No.'" role="button" placement="bottom" [ngbTooltip]="item.value ? item.value : null"
            class="list-item-value d-inline-block text-truncate fw-semibold primary-font">
            {{ item.value ?? '-'}}
          </span>
          <span *ngIf="item.key == 'SB No.'" role="button" placement="bottom" [ngbTooltip]="item.value ? item.value : null"
            class="list-item-value d-inline-block text-truncate fw-semibold font-16"(click)="onsourcingbatchclick(item)">
            {{ item.value ?? '-'}}
          </span>
         <span *ngIf="item?.badge" class="badge badge-red text-nowrap">{{item.value ?? 'NA' }}</span>
        </div>
      </ng-container>
    </div>

    <div class="collapse-btn align-self-start d-flex align-items-center gap-2 gap-sm-3 text-nowrap">
      <!-- <i class="font-14 text-nowrap">Reminders {{reminderOn ? 'On' :'Off'}}</i> -->
      <img class="hand" (click)="onClick()" src="./assets/SVGIcons/{{isExpanded ? 'uparrow' : 'downarrow'}}.svg" alt="" />
    </div>
  </div>
</div>